export default "__VITE_ASSET__BnH6SIsD__"